<template>
    <router-link
        class="resources-folder-card-root"
        :to="this.$URLS.internalResources.concat('/').concat(id)"
    >
        <div @click="logResourceNodeClickEvent">
            <Paper style="overflow:hidden">
                <img :src="imageUrl" alt="folder" class="resources-folder-card-image" />
                <div class="resources-folder-data-wrapper">
                    <ResourcesFolderCardHeader :title="title" :file-count="fileCount" />
                    <p class="resources-folder-data-description">
                        {{ description }}
                    </p>
                </div>
            </Paper>
        </div>
    </router-link>
</template>

<script>
// Services
import AnalyticService from '~/services/AnalyticService';

// Components
import Paper from '../../../../components/builders/Paper';
import ResourcesFolderCardHeader from './ResourcesFolderCardHeader';
import FolderIcon from '~/assets/img/Folder-icon.png';

export default {
    name: 'ResourcesFolderCard',
    components: { ResourcesFolderCardHeader, Paper },
    props: {
        description: String,
        fileCount: Number,
        image: String,
        title: String,
        id: String,
    },
    computed: {
        imageUrl() {
            if (this.image && this.image !== '' && this.image !== ' ') {
                return this.image;
            } else {
                return this.emptyFolderIcon;
            }
        },
    },
    data: () => ({
        emptyFolderIcon: FolderIcon,
        hasLoggedResourceNodeClickEvent: false,
    }),
    methods: {
        async logResourceNodeClickEvent() {
            if (this.hasLoggedResourceNodeClickEvent) return;
            AnalyticService.resourceNodeClickEvent(this.id);
            this.hasLoggedResourceNodeClickEvent = true;
        },
    },
};
</script>

<style scoped>
.resources-folder-card-root {
    text-decoration: none;
    color: black;
    transition: margin 0.1s;
}
.resources-folder-card-root:hover {
    margin-left: -5px;
    margin-right: -5px;
}
.resources-folder-card-root:hover img {
    height: 210px;
}
.resources-folder-card-image {
    padding: 15px;
    width: 100%;
    object-fit: contain;
    height: 200px;
    transition: height 0.1s;
}
.resources-folder-data-wrapper {
    padding: 15px;
}
.resources-folder-data-description {
    text-overflow: ellipsis;
    font-size: 12px;
}
</style>
